var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:1.91px;}.cls-2{stroke-linecap:square;}")), /*#__PURE__*/React.createElement("g", {
    id: "money_stack",
    "data-name": "money stack"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.36,
    y1: 15.82,
    x2: 6.27,
    y2: 15.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.73,
    y1: 15.82,
    x2: 19.64,
    y2: 15.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.5,
    y: 9.14,
    width: 21,
    height: 13.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.41,
    y1: 5.32,
    x2: 20.59,
    y2: 5.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.32,
    y1: 1.5,
    x2: 18.68,
    y2: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12,
    cy: 15.82,
    r: 3.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.36,
    y1: 15.82,
    x2: 6.27,
    y2: 15.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.73,
    y1: 15.82,
    x2: 19.64,
    y2: 15.82
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/business-icon.acbc1f67ecabe67c3813d0c0d17ce8b8.svg";
export { ForwardRef as ReactComponent };